<!-- D17 — the app-shell skip link. First in tab order, before the global navigation, and it
     targets the routed main content so keyboard and screen-reader users can bypass the whole
     header on every page. -->
<a class="skip-link" href="#main-content" (click)="skipToMainContent($event)"
  >Skip to main content</a
>
@if (blurCover) {
  <div class="cover"></div>
}
@if (
  !isBarePdfViewerRoute() &&
  !sourceWindowRoute() &&
  (displayCookieBanner$ | async)
) {
  <syrf-cookie-consent-banner
    (accepted)="dismissCookieBanner()"
  ></syrf-cookie-consent-banner>
}
<div
  class="site-container"
  [class.source-window-shell]="sourceWindowRoute()"
  [style.--app-header-height.px]="headerHeight()"
  gdAreas="        nav   |
                                                          content |
                                                          footer"
  gdRows="auto 1fr auto"
>
  @if (!isBarePdfViewerRoute()) {
    <div
      gdArea="nav"
      class="nav-container"
      id="app-toolbar"
      [hidden]="sourceWindowRoute()"
      #appToolbar
      fxLayout="column"
    >
      <!-- Environment warning banner for non-production environments -->
      <app-environment-banner
        [dismissible]="true"
        (dismissed)="dismissEnvironmentBanner()"
        (infoClicked)="openEnvironmentWarning()"
      ></app-environment-banner>
      <!-- Impersonation warning banner for admin users acting as another user -->
      <app-impersonation-banner></app-impersonation-banner>
      <app-nav [appIsUnstable]="(appIsUnstable$ | async) || false"></app-nav>
      <!--    <app-debugger-group>-->
      <!--      <app-debugger-->
      <!--        title="Projects Loading"-->
      <!--        [json]="projectsLoading$ | async"-->
      <!--      />-->
      <!--      <app-debugger title="Project Loading" [json]="projectLoading$ | async" />-->
      <!--      <app-debugger title="Study Loading" [json]="studyLoading$ | async" />-->
      <!--    </app-debugger-group>-->
      @if (showLoadingIndicator$ | async) {
        <mat-progress-bar
          mode="query"
          id="search-loading-bar"
        ></mat-progress-bar>
      }
    </div>
  }

  <div
    class="body-content"
    id="main-content"
    tabindex="-1"
    gdArea="content"
    fxLayout="column"
  >
    <router-outlet></router-outlet>
  </div>
  <!-- <div fxFlex="grow"></div> -->
  @if (!isBarePdfViewerRoute()) {
    <footer #appFooter gdArea="footer" [hidden]="sourceWindowRoute()">
      <mat-divider></mat-divider>
      <div class="footer-content">
        <div class="footer-brand">
          <a
            href="http://www.dcn.ed.ac.uk/camarades"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="CAMARADES website (opens in a new tab)"
          >
            <picture>
              <source
                [attr.srcset]="camaradesLogoBase() + '.webp'"
                type="image/webp"
              />
              <source
                [attr.srcset]="camaradesLogoBase() + '.png'"
                type="image/png"
              />
              <!-- The img element is required as a fallback -->
              <img
                class="footer-logo"
                [src]="camaradesLogoBase() + '.png'"
                data-testid="footer-camarades-logo"
                alt="CAMARADES Logo"
              />
            </picture>
          </a>
        </div>
        <div class="footer-centre">
          <nav class="footer-links" aria-label="Footer">
            <a mat-button [routerLink]="['about/cookies']">Cookies</a>
            <a mat-button [routerLink]="['about/privacy']">Privacy</a>
            <a mat-button [routerLink]="['about/accessibility']"
              >Accessibility Statement</a
            >
            <a mat-button [routerLink]="['contact-us']">Contact Us</a>
            <a
              id="footer-x"
              mat-icon-button
              href="https://x.com/CAMARADES_"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="CAMARADES on X (opens in a new tab)"
            >
              <mat-icon svgIcon="x-logo"></mat-icon>
            </a>
          </nav>
          <div class="footer-notes">
            <span>SyRF &copy; {{ currentYear }}</span>
            <app-environment-indicator
              (clicked)="openVersionInfo()"
            ></app-environment-indicator>
            <span>All rights reserved</span>
          </div>
          <!-- <pre>{{ environment | json }}</pre>
        <pre>{{ config | json }}</pre> -->
          <!-- <pre>{{ name | json }}</pre> -->
        </div>
        <div class="footer-brand">
          <a
            href="https://www.nc3rs.org.uk"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="NC3Rs website (opens in a new tab)"
          >
            <!-- Both brandmarks are transparent vector artwork from the official EPS; the
                 white one is swapped in whenever the effective theme is dark, so it changes
                 live with the toggle and the system preference. -->
            <img
              class="footer-logo"
              [src]="nc3rsBrandmarkSrc()"
              data-testid="footer-nc3rs-logo"
              alt="NC3Rs Logo"
            />
          </a>
        </div>
      </div>
    </footer>
  }
</div>
